import { shellSlots, type FeatureRoute, type SlotContribution } from '@/shared/registry'
import { myDataSlot } from '@/shared/search/my-data'
import { User } from '@/shared/ui/icons'

import { myDataApi, myProfilePath } from './paths'

/** My Profile (SM-15). */
export const myProfileRoutes: readonly FeatureRoute[] = [
  {
    path: myProfilePath,
    titleId: 'siteManagement.myProfile.title',
    page: () => import('./MyProfilePage').then((module) => module.MyProfilePage),
  },
]

/** My Profile in the account menu, the "complete your profile" step after sign-in, and Site Management's part of "Download my data". */
export const myProfileSlots: readonly SlotContribution[] = [
  { kind: 'link', slot: myDataSlot, id: 'site-management.my-data', labelId: 'siteManagement.myData.part', path: myDataApi },
  {
    kind: 'link',
    slot: shellSlots.accountMenu,
    id: 'my-profile',
    labelId: 'siteManagement.myProfile.title',
    icon: User,
    path: myProfilePath,
  },
  {
    // Applies the person's own language and time zone; shows nothing.
    kind: 'panel',
    slot: shellSlots.gates,
    id: 'my-locale-preference',
    component: () => import('./MyLocalePreference').then((module) => module.MyLocalePreference),
  },
  {
    // Holds a person until they fill in the site's required fields and those an administrator flagged.
    kind: 'panel',
    slot: shellSlots.gates,
    id: 'complete-profile',
    component: () => import('./CompleteProfileGate').then((module) => module.CompleteProfileGate),
  },
]
